import { useState } from "react";
import Modal from "../Modal/Modal";
import './scalable-image.scss'
type ScalableImageType = {
    src: string,
    alt: string
}

const ScalableImage = (props: ScalableImageType) =>{
    const [isExpanded, setIsExpanded] = useState(false);
    return(
        <div className="image">
            <img className="blur-background" src={props.src} alt={props.alt} loading="lazy" onClick={() => {setIsExpanded(true)}}/>
            <Modal isOpen={isExpanded} handleClose={() => {setIsExpanded(false)}}>
                <img className="blur-background expanded" src={props.src} alt={props.alt} loading="lazy" onClick={() => {setIsExpanded(true)}}/>
            </Modal>
        </div>
    )
}
export default ScalableImage;